
export const scrollToTextListRefItem = (textListRef, id) => {
    // Access the specific DOM node and call scrollIntoView
    if (textListRef.current[id]) {
      textListRef.current[id].scrollIntoView({
        behavior: 'smooth', // Smooth scrolling effect
        block: 'start', // Align the top of the element with the top of the viewport
      });

      return true;
      
    } else {
      return false;
    }
  };